module.exports = __webpack_public_path__ + "img/thumbnail_RingTailedLemur_f_normal.05369292.png";